// extracted by css-extract-rspack-plugin
module.exports =  {"title":"styles__title___JJ8C0","description":"styles__description___wiGFs","signInButton":"styles__signInButton___TmkZL"};